"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createData;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _KansaAnswerConsts = require("../../common/consts/KansaAnswerConsts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査回答情報一時配列格納（見出しラベル編集）
 * @prop {Object} [data] -ラベル部分に表示する内容
 * @prop {Object} [state] -呼出し元のステート変数
 */
function createData(data, state) {
  const {
    svData
  } = state;
  let savecColumnCd = '';
  let idx = 0;
  let kisoPoint = 0;
  let katenPoint = 0;
  let confirmFlg = true;
  for (let i = 0; i < data.length; i++) {
    let item = data[i];
    item.dispFlg = false;
    if (data[i].chosaColumnCd !== savecColumnCd) {
      if (idx > 0) {
        let dat = svData[idx - 1];
        dat.dispFlg = true;
        svData[idx - 1].referencePoints = confirmFlg ? dat.standardPoints - kisoPoint + katenPoint : _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU;
        kisoPoint = 0;
        katenPoint = 0;
      }
      savecColumnCd = data[i].chosaColumnCd;
      svData[idx] = {
        recordKbn: _KansaAnswerConsts.CONSTS.REC_HEAD_KBN,
        kakuninJiko: _stringUtil.default.emptyToHyphen(data[i].chosaColumnNm)
      };
      idx++;
      item.recordKbn = _KansaAnswerConsts.CONSTS.REC_DETAIL_KBN;
      svData[idx] = item;
      confirmFlg = true;
    } else {
      item.recordKbn = _KansaAnswerConsts.CONSTS.REC_DETAIL_KBN;
      svData[idx] = item;
    }
    if (item.basicAddpointKbnCd === _CodeConsts.CODE.BASE_DEBIT_CD.CODE_1) {
      if (item.kakuninKekkaCd === _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_2) {
        kisoPoint += item.points;
      }
    }
    if (item.basicAddpointKbnCd === _CodeConsts.CODE.BASE_DEBIT_CD.CODE_2) {
      if (item.kakuninKekkaCd === _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_1) {
        katenPoint += item.points;
      }
    }
    if (item.kakuninKekkaCd === null || item.kakuninKekkaCd === ' ' || item.kakuninKekkaCd === '') {
      confirmFlg = false;
    }
    idx++;
  }
  let dat = svData[idx - 1];
  svData[idx - 1].referencePoints = confirmFlg ? dat.standardPoints - kisoPoint + katenPoint : _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU;
  dat.dispFlg = true;
}